const drawers = document.querySelectorAll('[data-matter-about-drawer]');

document.addEventListener('click', (event) => {
  drawers.forEach((drawer) => {
    if (drawer.open && !drawer.contains(event.target)) drawer.removeAttribute('open');
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  drawers.forEach((drawer) => {
    if (!drawer.open) return;
    drawer.removeAttribute('open');
    drawer.querySelector('summary')?.focus();
  });
});
